<template>
  <footer>
    <div class="pages">
      <div class="left">
        <div class="page-container" v-for="page in pages" :key="page.title">
          <div class="text-title">{{ page.title }}</div>
          <div class="list">
            <div class="text-item" v-for="item in page.list" :key="item.name">
              <router-link :to="item.path">{{ item.name }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="text-title">{{ $t("footer.certification") }}</div>
        <div class="list">
          <div class="text-item">{{ $t("footer.certificationSilk") }}</div>
          <div class="text-item">
            {{ $t("footer.certificationXiangyunsha") }}
          </div>
          <div class="text-item">
            {{
              $t("footer.certificationCertificateNumber", {
                number: "FS-2025-MPC-780100",
              })
            }}
          </div>
          <div class="text-item">
            {{
              $t("footer.certificationCertificateNumber", {
                number: "FS-2025-MPC-586511",
              })
            }}
          </div>
        </div>
        <div class="origin">
          {{ $t("footer.certificationOrigin") }}
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="contact">
      <div class="left">
        <div class="contact-title">{{ $t("nav.contact") }}</div>
        <div class="contact-info">
          <img
            class="phone-icon"
            src="https://img.shineinto.com/static/phone.svg"
          />
          <span>400-169-9929</span>
        </div>
        <div class="contact-info">
          <img src="https://img.shineinto.com/static/location-white.svg" />
          <span>
            {{ $t("footer.contactAddress") }}
          </span>
        </div>
      </div>
      <div class="right">
        <template v-for="(item, index) in getPlatformInfos">
          <el-popover
            v-if="item.qrCode"
            :key="'popover' + index"
            placement="top-start"
            width="120"
            trigger="hover"
          >
            <div><img class="qrcode" :src="item.qrCode" /></div>
            <img
              slot="reference"
              :alt="item.platform"
              class="icon"
              :src="item.logo"
              @click="navigateTo(item.link)"
            />
          </el-popover>
          <img
            v-else
            :key="'img' + index"
            class="icon"
            :src="img.logo"
            :alt="item.platform"
            @click="navigateTo(item.link)"
          />
        </template>
      </div>
    </div>
    <div class="divider divider2"></div>
    <div class="copyright">
      <div class="left">
        <span>{{ $t("footer.copyright") }}</span>
        <span>{{ getIcp }}</span>
      </div>
      <ul class="right">
        <!-- <li>{{ $t("footer.privacyPolicy") }}</li>
        <li>{{ $t("footer.legalStatement") }}</li> -->
      </ul>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CustomFooter",
  computed: {
    ...mapGetters("system", ["getIcp", "getPlatformInfos"]),
    pages() {
      return [
        {
          title: this.$t("nav.brand"),
          list: [
            {
              name: this.$t("nav.brandStory"),
              path: "/",
            },
            {
              name: this.$t("nav.designerStory"),
              path: "/designer-story",
            },
            {
              name: this.$t("nav.brandCraftsmanship"),
              path: "/brand-craftsmanship",
            },
            {
              name: this.$t("nav.brandBlockbuster"),
              path: "/brand-blockbuster",
            },
          ],
        },
        {
          title: this.$t("nav.news"),
          list: [
            {
              name: this.$t("nav.latest"),
              path: "/news/latest",
            },
            {
              name: this.$t("nav.media"),
              path: "/news/media",
            },
            {
              name: this.$t("nav.activity"),
              path: "/news/activity",
            },
            {
              name: this.$t("nav.trend"),
              path: "/news/trend",
            },
          ],
        },
        {
          title: this.$t("nav.map"),
          list: [
            {
              name: this.$t("nav.mapDistribution"),
              path: "/map",
            },
            {
              name: this.$t("nav.mapDetail"),
              path: "/map",
            },
          ],
        },
        {
          title: this.$t("nav.contact"),
          list: [
            {
              name: this.$t("nav.contactInfo"),
              path: "/contact",
            },
            {
              name: this.$t("nav.cooperation"),
              path: "/contact",
            },
          ],
        },
      ];
    },
  },
  methods: {
    navigateTo(path) {
      path && window.open(path, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
footer {
  background-color: rgba(33, 30, 29, 1);
  // position: sticky;
  // bottom: 0;
  // z-index: 99;
  .pages {
    padding: 91px 105px 57px 109px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .text-title {
      line-height: 28px;
      color: #f1f0f0;
      font-size: 20px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .text-item {
      margin-top: 17px;
      line-height: 23px;
      color: #b1b1b1;
      font-size: 16px;
      white-space: nowrap;
      a {
        line-height: 23px;
        color: #b1b1b1;
        font-size: 16px;
        text-decoration: none;
        &:hover,
        &:active {
          color: #f1f0f0;
        }
      }
    }
    .left {
      display: flex;
      .page-container {
        width: 223px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .list {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
    .right {
      width: 620px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .text-item {
          width: 290px;
          text-align: left;
        }
      }
      .origin {
        line-height: 23px;
        color: #b1b1b1;
        font-size: 16px;
        margin-top: 57px;
      }
    }
  }
  .divider {
    margin: 58px 0;
    border-top: 1px solid #bbbbbb;
    transform: scaleY(0.5);
  }
  .divider2 {
    margin: 58px 0 27px;
  }
  .contact {
    padding: 0 105px 0 109px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      text-align: left;
      .contact-title {
        line-height: 28px;
        color: #f1f0f0;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 32px;
      }
      .contact-info {
        display: flex;
        align-items: center;
        line-height: 23px;
        color: #f1f0f0;
        font-size: 16px;
        + .contact-info {
          margin-top: 17px;
        }
        img {
          height: 24px;
          filter: brightness(0) invert(1);
          margin-right: 10px;
        }
      }
    }
    .right {
      display: flex;
      gap: 24px;
      align-items: center;
      .icon {
        height: 24px;
        cursor: pointer;
      }
    }
  }
  .copyright {
    padding: 0 105px 28px 108px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 23px;
    color: rgba(177, 177, 177, 1);
    font-size: 16px;
    .left > span:not(:last-child) {
      margin-right: 26px;
    }
    ul {
      display: flex;
      list-style: none;
      li:hover {
        color: #f1f0f0;
        cursor: pointer;
      }
      li:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
}
</style>

<style>
.qrcode {
  width: 100%;
}
</style>

<style lang="less" scoped>
@media screen and (max-width: 48rem) {
  footer {
    .pages {
      padding: 72px 0 0;
      flex-direction: column;
      .text-title {
        line-height: 20px;
        font-size: 14px;
        margin-bottom: 0px;
      }
      .text-item {
        margin-top: 20px;
        line-height: 17px;
        font-size: 12px;
        white-space: unset;
        a {
          line-height: 17px;
          font-size: 12px;
          text-decoration: none;
        }
      }
      .left {
        width: 100%;
        padding: 0 32px 45px;
        position: relative;
        justify-content: space-between;
        .page-container {
          width: unset;
          max-width: 82px;
        }
        &:after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          border-bottom: 1px solid #bbbbbb;
          transform: scaleY(0.5);
        }
      }
      .right {
        width: 100%;
        padding: 45px 32px 0;
        .list {
          width: 100%;
          display: flex;
          flex-direction: column;
          .text-item {
            width: 100%;
            order: 1;
            &:nth-of-type(2) {
              order: 3;
            }
            &:nth-of-type(3) {
              margin-top: 7px;
              order: 2;
            }
            &:nth-of-type(4) {
              margin-top: 7px;
              order: 4;
            }
          }
        }
        .origin {
          line-height: 17px;
          font-size: 12px;
          margin-top: 26px;
        }
      }
    }
    .divider {
      margin: 45px 0;
    }
    .divider2 {
      margin: 45px 0;
    }
    .contact {
      padding: 0 32px;
      flex-direction: column;
      align-items: flex-end;
      gap: 45px;
      .left {
        width: 100%;
        .contact-title {
          line-height: 28px;
          font-size: 20px;
          margin-bottom: 26px;
        }
        .contact-info {
          line-height: 17px;
          font-size: 12px;
          + .contact-info {
            margin-top: 13px;
          }
          img {
            height: 20px;
            margin-right: 14px;
          }
        }
      }
      .right {
        gap: 17px;
        .icon {
          height: 18px;
        }
        ::v-deep .el-popover__reference-wrapper {
          display: flex;
          align-items: center;
        }
      }
    }
    .copyright {
      padding: 0 32px 77px 32px;
      flex-direction: column;
      line-height: 17px;
      font-size: 12px;
      align-items: flex-start;
      gap: 36px;
      .left {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      .left > span:not(:last-child) {
        margin-right: 0;
      }
      ul {
        display: flex;
        list-style: none;
        li:hover {
          color: #f1f0f0;
          cursor: pointer;
        }
        li:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
